// shared environment variables which will be provided by the release build
export const ENVIRONMENT_VARIABLES = {
  // env variables from release
  RELEASE_CI_PIPELINE_ID: 'RELEASE_CI_PIPELINE_ID',
  RELEASE_COMMIT_ID: 'RELEASE_COMMIT_ID',
  RELEASE_DATETIME: 'RELEASE_DATETIME',
  RELEASE_TAG: 'RELEASE_TAG',

  // env variables from vite
  VITE_ENVIRONMENT: 'VITE_ENVIRONMENT',
  VITE_APP_VERSION: 'VITE_APP_VERSION',
  VITE_I18N_LOCALE: 'VITE_I18N_LOCALE',
  VITE_I18N_FALLBACK_LOCALE: 'VITE_I18N_FALLBACK_LOCALE',
  VITE_DEEP_ID_BE_URL: 'VITE_DEEP_ID_BE_URL',
  VITE_DEEP_ID_API: 'VITE_DEEP_ID_API',
  VITE_DEEP_ID_BRANCH_IO: 'VITE_DEEP_ID_BRANCH_IO',
  VITE_DEEP_ID_EVENT_STREAM: 'VITE_DEEP_ID_EVENT_STREAM',
  VITE_DEEP_ID_FILE_STREAM: 'VITE_DEEP_ID_FILE_STREAM',
  VITE_APPS_DEEP_ID_URL_DEVICE_HANDOVER:
    'VITE_APPS_DEEP_ID_URL_DEVICE_HANDOVER',
  VITE_APPS_DEEP_ID_URL_FRONTEND: 'VITE_APPS_DEEP_ID_URL_FRONTEND',
  VITE_BRANCH_IO_BASE_URL: 'VITE_BRANCH_IO_BASE_URL',
  VITE_BRANCH_IO_KEY: 'VITE_BRANCH_IO_KEY',
  VITE_EXTERNAL_APP_LOOKUP: 'VITE_EXTERNAL_APP_LOOKUP',
  VITE_GATEWAY_API_KEY: 'VITE_GATEWAY_API_KEY',
} as const

export type EnvironmentVariables = keyof typeof ENVIRONMENT_VARIABLES

export const VITE_ENVIRONMENT = {
  Local: 'local',
  Sandbox: 'sandbox',
  Dev: 'dev',
  Test: 'test',
  Prod: 'prod',
} as const
